import { useState, useEffect } from 'react';
import { getRenderedTransactions } from '../data/api/api';

const useRenderedTransactions = (partnerId) => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [totalCount, setTotalCount] = useState(0);

  const fetchTransactions = async () => {
    if (!partnerId) return;
    
    setLoading(true);
    setError(null);
    
    try {
      const response = await getRenderedTransactions(partnerId);
      
      if (response.success) {
        const safeData = Array.isArray(response.data) 
          ? response.data.filter(item => item !== null && item !== undefined)
          : [];
        setTransactions(safeData);
        setTotalCount(response.total_count || safeData.length);
        setError(null);
      } else {
        if (response.isNotFound || response.statusCode === 404) {
          setError(null);
          setTransactions([]);
          setTotalCount(0);
        } else {
          const errorMessage = response.message || response.error || 'Failed to fetch rendered transactions';
          setError(errorMessage);
          setTransactions([]);
          setTotalCount(0);
        }
      }
    } catch (err) {
      if (err.response?.status === 404) {
        setError(null);
        setTransactions([]);
        setTotalCount(0);
      } else {
        const errorMessage = err.response?.data?.message 
          || err.response?.data?.error 
          || err.message 
          || 'An unexpected error occurred';
        setError(errorMessage);
        setTransactions([]);
        setTotalCount(0);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [partnerId]);

  return { 
    transactions, 
    loading, 
    error, 
    totalCount,
    refetch: fetchTransactions 
  };
};

export default useRenderedTransactions;

